import React, { useEffect } from "react";
import { StatusBar, Style } from "@capacitor/status-bar";
import { Capacitor } from "@capacitor/core";

import Styles from "./ProfileHeader.styles";
import { ProfileHeaderProps as Props } from "./ProfileHeader.types";
import { useFetchUser } from "services/user/user.service.hooks";
import useAuth from "contexts/auth/auth.context.hooks";
import ProfileHeaderPlaceholder from "./ProfileHeader.placeholder";
import variables from "styles/util/variables";

const ProfileHeader: React.FC<Props> = props => {
  const { className } = props;

  const { data: user, isLoading } = useFetchUser();
  const { isAnonymous } = useAuth();

  useEffect(() => {
    if (Capacitor.getPlatform() === "web") return;

    const isIOS = Capacitor.getPlatform() === "ios";
    const isAndroid = Capacitor.getPlatform() === "android";

    if (isAndroid) {
      StatusBar.setBackgroundColor({
        color: variables.palette["black-s0-l10-hex"]
      });
    }

    if (isIOS || isAndroid) {
      StatusBar.setStyle({ style: Style.Dark });
    }

    return () => {
      StatusBar.setStyle({ style: Style.Light });

      if (isAndroid) {
        StatusBar.setBackgroundColor({ color: variables.palette["white-hex"] });
      }
    };
  }, []);

  return (
    <Styles className={`ProfileHeader ${className}`}>
      {isLoading ? (
        <ProfileHeaderPlaceholder />
      ) : (
        <p className="ProfileHeader__title">
          {!isAnonymous ? (
            <>
              Bienvenido/a <br />
              {user?.name}
            </>
          ) : (
            <>
              Bienvenido/a a <br />
              Pizzeria el Hornero
            </>
          )}
        </p>
      )}
    </Styles>
  );
};

ProfileHeader.defaultProps = {
  className: ""
};

export default ProfileHeader;
